import React, { RefObject, useMemo, useRef } from 'react';
import { IconBox } from 'src/ui/common/atoms/icon-box';
import { MoreIcon } from 'src/ui/common/atoms/more-icon';
import { SvgIcon } from 'src/ui/common/atoms/svg-icon';
import { SvgIconRegular } from 'src/ui/common/atoms/svg-icon/svg-icon.types';
import { Typography } from 'src/ui/common/atoms/typography';
import { SimpleDropDown } from 'src/ui/common/organisms/simple-dropdown';
import {
    StyledDropDownItem,
    StyledSite,
    StyledSocialsContainer,
    StyledSocialsList,
    StyledVisible,
} from './entity-layout.styles';
import { IEntityLayoutSocials } from './entity-layout.types';

export const EntityLayoutSocials = ({ socialNetworks, openShareModal }: IEntityLayoutSocials) => {
    const threeDotsRef = useRef() as RefObject<HTMLDivElement>;
    const siteLink = socialNetworks.find((link) => link.type === 'Site');

    const SiteLink = useMemo(
        () =>
            siteLink ? (
                <StyledSite href={siteLink.identifier} target="_blank" rel="noreferrer">
                    <SvgIcon variant="regular" icon={siteLink.type.toLocaleLowerCase() as SvgIconRegular['icon']} />
                    <Typography overflowLines={1} size="xs" color="text">
                        {siteLink.identifier}
                    </Typography>
                </StyledSite>
            ) : null,
        [siteLink]
    );

    const socialsWithoutSite = useMemo(() => socialNetworks.filter((link) => link.type !== 'Site'), [socialNetworks]);

    return (
        <>
            <StyledVisible view="desktop">
                <StyledSocialsContainer justifyContent="flex-end">
                    {!!socialNetworks.length && (
                        <StyledSocialsList>
                            {SiteLink}
                            {socialsWithoutSite.map((link) => (
                                <a key={link.type} href={link.identifier} target="_blank" rel="noreferrer">
                                    <IconBox icon={link.type.toLocaleLowerCase() as any} />
                                </a>
                            ))}
                        </StyledSocialsList>
                    )}
                    <IconBox onClick={openShareModal} icon="share" />
                </StyledSocialsContainer>
            </StyledVisible>
            <StyledVisible view={['laptop', 'mobile']}>
                <StyledSocialsContainer justifyContent="flex-end">
                    <MoreIcon ref={threeDotsRef} />
                    {/* @ts-ignore */}
                    <SimpleDropDown nodeRef={threeDotsRef} horizontalBindTo="right">
                        {SiteLink}
                        {socialsWithoutSite.map((link) => (
                            <StyledDropDownItem key={link.type} href={link.identifier} target="_blank" rel="noreferrer">
                                <SvgIcon variant="regular" icon={link.type.toLocaleLowerCase() as any} />
                                <span>{link.type}</span>
                            </StyledDropDownItem>
                        ))}
                        <StyledDropDownItem onClick={openShareModal} as="div" noSeparator={!socialNetworks.length}>
                            <SvgIcon variant="regular" icon="share" />
                            <span>Share</span>
                        </StyledDropDownItem>
                    </SimpleDropDown>
                </StyledSocialsContainer>
            </StyledVisible>
        </>
    );
};
